@if ({}; as STATE) {
  <section class="signup-page">
    <auth-wrapper [title]="title" [description]="description"
      ><signup-stepper></signup-stepper
    ></auth-wrapper>
  </section>
}
